module.exports = __webpack_public_path__ + "static/media/logo.ab10d000.png";